import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { usePageMeta } from "@/hooks/usePageMeta";
import ContactForm from "@/pages/contact/components/ContactForm";

const contacts = [
  { icon: "ri-phone-line", label: "咨询热线", value: "400-826-2026", note: "每日 09:30 - 22:30" },
  { icon: "ri-mail-line", label: "电子邮箱", value: "hello@domecinema.cn", note: "24 小时内回复" },
  { icon: "ri-map-pin-2-line", label: "场馆地址", value: "上海市浦东新区星海大道 88 号", note: "穹顶艺术中心 B1" },
  { icon: "ri-wechat-line", label: "微信公众号", value: "DomeCinema", note: "获取最新放映动态" },
];

export default function Contact() {
  usePageMeta(
    "联系我们-球幕影院联系方式与在线留言",
    "联系球幕影院：咨询热线、电子邮箱、场馆地址与到店路线，并可通过在线留言表单与我们取得联系。",
    "球幕影院联系方式,联系我们,场馆地址,在线留言,观影咨询",
  );
  return (
    <div className="w-full pt-20">
      <section className="bg-background-100/60 border-b border-background-200/60">
        <div className="max-w-content mx-auto px-4 md:px-8 py-12 md:py-16">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-5" aria-label="面包屑">
            <Link to="/" className="hover:text-accent-500 transition-colors cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">联系我们</span>
          </nav>
          <h1 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">联系我们</h1>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
            无论是影片咨询、场次预约还是团体合作，都欢迎随时与我们联系，我们会尽快回复你。
          </p>
        </div>
      </section>

      <section className="max-w-content mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {contacts.map((item, i) => (
            <Reveal key={item.label} delay={i * 70}>
              <div className="h-full p-5 rounded-lg bg-background-100 border border-background-200/70">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-500/15 text-accent-500 text-xl mb-4">
                  <i className={item.icon} />
                </span>
                <p className="text-xs text-foreground-500 mb-1.5">{item.label}</p>
                <p className="font-heading font-semibold text-foreground-950 text-sm mb-1">{item.value}</p>
                <p className="text-xs text-foreground-500">{item.note}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-content mx-auto px-4 md:px-8 pb-14 md:pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-5">场馆位置</h2>
            <div className="rounded-lg overflow-hidden border border-background-200/70 bg-background-100 h-[360px]">
              <iframe
                title="球幕影院场馆位置地图"
                src="https://maps.google.com/maps?q=%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%B5%A6%E4%B8%9C%E6%96%B0%E5%8C%BA&z=13&output=embed"
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="mt-4 p-5 rounded-lg bg-background-100 border border-background-200/70">
              <h3 className="font-heading font-semibold text-foreground-950 mb-3">到店路线</h3>
              <ul className="flex flex-col gap-2.5 text-sm text-foreground-600">
                <li className="flex items-start gap-2.5">
                  <i className="ri-subway-line text-accent-500 mt-0.5" />
                  地铁 2 号线「星海路站」3 号口出，步行 5 分钟
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="ri-bus-line text-accent-500 mt-0.5" />
                  公交 81 / 993 路「穹顶艺术中心站」下车即达
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="ri-parking-box-line text-accent-500 mt-0.5" />
                  自驾可停 B2 地下停车场，观影凭票免费 3 小时
                </li>
              </ul>
            </div>
          </div>

          <div>
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}